import Instance from './resource';
import $ from "jquery";
export default {
  detilNumber(number) {
    let index;
  },
  //截取url数据方法
  getParam(name) {
    let search = String(document.location);
    let pattern = new RegExp("[?&]" + name + "\=([^&]+)", "g");
    let matcher = pattern.exec(search);
    let items = null;
    if (null != matcher) {
      try {
        items = decodeURIComponent(decodeURIComponent(matcher[1]));
      } catch (e) {
        try {
          items = decodeURIComponent(matcher[1]);
        } catch (e) {
          items = matcher[1];
        }
      }
    }
    let strIndex = items.indexOf("#");
    let str;
    if (strIndex != -1) {
      str = items.substr(0, strIndex)
    } else {
      str = items;
    }
    return str;
  },
  //判断是否是整数
  isNum(index) {
    let type = "^[0-9]*[1-9][0-9]*$";
    let r = new RegExp(type);
    let flag = r.test(index);
    if (flag) {
      return true;
    } else {
      return false;
    }
  },
  //单位处理成万
  detailWan(num) {
    let endNumber;
    if (num >= 0) {
      if ((num / 10000) < 1) {
        endNumber = num;
      } else if ((num / 10000) < 10000 && (num / 10000) >= 1) {
        endNumber = (num / 10000) + "万";
      } else if ((num / 100000000) >= 1) {
        endNumber = (num / 100000000).toFixed(4) + "亿";
      }
    } else {
      num = 0 - num;
      if ((num / 10000) < 1) {
        endNumber = -num;
      } else if ((num / 10000) < 10000 && (num / 10000) >= 1) {
        endNumber = -(num / 10000) + "万";
      } else if ((num / 100000000) >= 1) {
        endNumber = -(num / 100000000).toFixed(4) + "亿";
      }
    }
    return endNumber;
  },
  // 将单位是万的转换为元
  detailYuan(str1) {
    let endNum;
    let str = String(str1);
    if (str.indexOf("万") == -1 && str.indexOf("亿") == -1) {
      endNum = str;
    } else if (str.indexOf("万") != -1) {
      endNum = Number(str.substr(0, str.indexOf("万"))) * 10000;
    } else if (str.indexOf("亿") != -1) {
      endNum = Number(str.substr(0, str.indexOf("亿"))) * 10000 * 10000;
    }
    return endNum;
  },

  //处理时间格式
  detailTime(time) {
    let date = new Date(time);
    let seperator1 = "-";
    let seperator2 = ":";
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    if (hours >= 0 && hours <= 9) {
      hours = "0" + hours;
    }
    if (minutes >= 0 && minutes <= 9) {
      minutes = "0" + minutes;
    }
    if (seconds >= 0 && seconds <= 9) {
      seconds = "0" + seconds;
    }

    let currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
      + " " + hours + seperator2 + minutes
      + seperator2 + seconds;
    return currentdate;
  },
  //处理日期格式
  detailDate(time) {
    let date = new Date(time);
    let seperator1 = "-";
    let seperator2 = ":";
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    let currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate;
    return currentdate;
  },
  //处理时间格式(月)
  detailmonth(time) {
    let date = new Date(time);
    let seperator1 = "-";
    let seperator2 = ":";
    let year = '';
    let month = date.getMonth() - 1;
    if (month <= 0) {
      month = month + 12;
      year = date.getFullYear() - 1
    } else {
      year = date.getFullYear()
    }
    let strDate = date.getDate();

    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    let currentdate = year + seperator1 + month + seperator1 + "01";
    return currentdate;
  },
//处理时间格式(只显示月)
detailmonthone(time) {
  let date = new Date(time);
  let seperator1 = "-";
  let seperator2 = ":";
  let year = '';
  let month = date.getMonth() + 1;
  if (month <= 0) {
    month = month + 12;
    year = date.getFullYear() - 1
  } else {
    year = date.getFullYear()
  }
  let strDate = date.getDate();

  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  let currentdate = year + seperator1 + month + seperator1 + "01";
  return currentdate;
},
detailmonthtow(time) {
  let date = new Date(time);
  let seperator1 = "-";
  let seperator2 = ":";
  let year = '';
  let month = date.getMonth() + 1;
  if (month <= 0) {
    month = month + 12;
    year = date.getFullYear() - 1
  } else {
    year = date.getFullYear()
  }
  let strDate = date.getDate();

  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  let currentdate = year + seperator1 + month;
  return currentdate;
},
  //每三位数加逗号
  addcomma(index) {
    let numstring = String(index);
    let x = numstring.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    let rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  },
  wipecomma(str) {
    let arr = str.split(",");
    let num = arr.join("")
    return Number(num)
  },
  forbidSclloer() {
    document.addEventListener('touchmove', this.preventTouchMove, false);
  },
  preventTouchMove(e) {
    e.stopPropagation()
    e.preventDefault()
  },
  starSclloer() {
    document.removeEventListener('touchmove', this.preventTouchMove, false)
  },
  //转换百分比
  changePercent(num) {
    let percent = (Number(num) / 100).toFixed(0);
    let str = percent + "%";
    return str;
  },
  percentChangeNum(str) {
    let strnum = String(str).split("%")[0];
    let num = Number(strnum) * 100;
    return num;
  }
}


// WEBPACK FOOTER //
// ./src/api/untils.js